import { $getRoot, $isElementNode, LexicalNode } from 'lexical';
import { $isReferenceCitationNode, ReferenceCitationNode } from '../../../nodes/ReferenceCitationNode';

export const $getReferenceCitationNodes = (node?: LexicalNode): ReferenceCitationNode[] => {
  const parent = node ?? $getRoot();

  if ($isReferenceCitationNode(parent)) {
    return [parent];
  }

  if (!$isElementNode(parent)) {
    return [];
  }

  const nodes: ReferenceCitationNode[] = [];
  parent.getChildren().forEach((child) => {
    nodes.push(...$getReferenceCitationNodes(child));
  });

  return nodes;
};
